import React from "react";
import { Segmented } from "antd";

const MySegmented = ({ options, value, setValue, className, size = 'middle', block = false }) => {
  return <Segmented size={size} options={options} value={value} onChange={setValue} className={`${className || ''}`} block={block} />
};

export default MySegmented;
